import { render, staticRenderFns } from "./CoursesContent.vue?vue&type=template&id=67234cf0&scoped=true"
import script from "./CoursesContent.vue?vue&type=script&lang=ts"
export * from "./CoursesContent.vue?vue&type=script&lang=ts"
import style0 from "./CoursesContent.vue?vue&type=style&index=0&id=67234cf0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67234cf0",
  null
  
)

export default component.exports